import { CommonData } from '../common_schema'

export const pdTsoData: CommonData[] = [
  {
    name: 'PD TSO Wait Duration',
    mean: 'P99_PD_wait_TSO_duration:total.values.mean',
    std: 'P99_PD_wait_TSO_duration:total.values.std',
    location: 'TiDB-Details --> PD Client --> PD TSO Wait Duration'
  },
  {
    name: 'PD TSO RPC Duration',
    mean: 'P99_PD_grpc_TSO_duration:total.values.mean',
    std: 'P99_PD_grpc_TSO_duration:total.values.std',
    location: 'TiDB-Details --> PD Client --> PD TSO RPC Duration'
  },
  {
    name: 'PD server TSO handle time + Client revc time(p99)',
    mean: 'P99_pd_server_handle_tso_duration:total.values.mean',
    std: 'P99_pd_server_handle_tso_duration:total.values.std',
    location: 'PD --> TiDB -->  PD server TSO handle time + Client revc time'
  },
  {
    name: 'Handle requests duration(tso average)',
    mean: 'PD_grpc_duration:total.values.mean',
    std: 'PD_grpc_duration:total.values.std',
    location: 'PD --> TiDB -->  Handle requests duration(tso average)'
  },
  {
    name: '99% Region heartbeat handle latency',
    mean: 'P99_Region_heartbeat_handle_latency:total.values.mean',
    std: 'P99_Region_heartbeat_handle_latency:total.values.std',
    location: 'PD --> Heartbeat --> 99% Region heartbeat handle latency'
  }
]
